import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  sharedSelectedRows = new BehaviorSubject<any>(null);
  currentSharedSelectedRows = this.sharedSelectedRows.asObservable();

  sharedSelectedExpandedRows = new BehaviorSubject<any>(null);
  currentSharedSelectedExpandedRows = this.sharedSelectedExpandedRows.asObservable();

  sharedSelectedSort = new BehaviorSubject<any>(null);
  currentSharedSelectedSort = this.sharedSelectedSort.asObservable();

  updateSharedSelectedRows(sharedSelectedRows: any) {
    this.sharedSelectedRows.next(sharedSelectedRows);
  }

  updateSharedSelectedExpandedRows(sharedSelectedExpandedRows: any) {
    this.sharedSelectedExpandedRows.next(sharedSelectedExpandedRows);
  }

  updateSharedSelectedSort(sharedSelectedSort: any) {
    this.sharedSelectedSort.next(sharedSelectedSort);
  }
}
